import { Group, Radio, TextInput, Box } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type {
  PsychomotorDevelopmentItem as PsychomotorDevelopmentItemType,
  PsychomotorDevelopmentType,
} from '@/types/psychomotor-development.types';

// -----------------------------------------------------------------------------
export interface PsychomotorDevelopmentInputItemProps {
  item: PsychomotorDevelopmentItemType;
  type: PsychomotorDevelopmentType;
  onValueChange: (value: boolean | null) => void;
  onObservationsChange: (observations: string) => void;
}

// -----------------------------------------------------------------------------
export const PsychomotorDevelopmentInputItem = ({
  item,
  type,
  onValueChange,
  onObservationsChange,
}: PsychomotorDevelopmentInputItemProps) => {
  const { t } = useTranslation(['patient-pages']);

  return (
    <Group wrap="nowrap" gap="xl">
      <Box miw={156}>
        <Radio.Group
          label={t(`psychomotorDevelopment.${type}`, {
            ns: 'patient-pages',
            defaultValue: type,
          })}
          value={item.value === null ? undefined : item.value ? 'yes' : 'no'}
          onChange={(value) => {
            const boolValue =
              value === 'yes' ? true : value === 'no' ? false : null;
            onValueChange(boolValue);
          }}
        >
          <Group mt="xs">
            <Radio
              value="yes"
              label={t('psychomotorDevelopment.yes', {
                ns: 'patient-pages',
                defaultValue: 'Yes',
              })}
            />
            <Radio
              value="no"
              label={t('psychomotorDevelopment.no', {
                ns: 'patient-pages',
                defaultValue: 'No',
              })}
            />
          </Group>
        </Radio.Group>
      </Box>
      <TextInput
        label={t('psychomotorDevelopment.observations', {
          ns: 'patient-pages',
          defaultValue: 'Observations',
        })}
        value={item.observations}
        onChange={(e) => onObservationsChange(e.currentTarget.value)}
        placeholder={t('psychomotorDevelopment.observationsPlaceholder', {
          ns: 'patient-pages',
          defaultValue: 'Enter observations...',
        })}
        flex={1}
      />
    </Group>
  );
};
